export type CustomDataReportParams = {
  catalogId: string;
  reportId: number;
};

export type DataDownloadsParams = {
  catalogId: string;
};

export type CreateDataDownloadParams = {
  catalogId: string;
  title?: string;
};

export enum ReportStatus {
  NOT_STARTED = 0,
  GENERATING = 1,
  GENERATED = 2,
  FAILED = 3,
}

export type DataDownloadInfo = {
  reportId: number;
  reportTitle: string;
  reportStatus: ReportStatus;
  reportTimestamp?: string | null;
  createdAt?: string | null;
  requesterUserId?: number | null;
  generatedAt?: string | null;
  fileGenerationStatus?: number | null;
  fileName?: string | null;
  fileId?: number | null;
  contentTitleText?: string | null;
  contentOption?: string | null;
  reportPrevStatus?: number | null;
  isDailySftp?: boolean;
  isSentDaily?: boolean;
  scheduledAt?: string | null;
  recipientUserIds?: number[];
  contentType?: string;
  url?: string | null;
  isDuplicatePlaceholder?: boolean;
  isDuplicate?: boolean;
  deleteOlderReports?: boolean;
};

export type DataDownloadFile = {
  fileId: number;
  finishedAt?: string | null;
  requesterUserId?: number | null;
  userName?: string | null;
  lastVisitedAt?: string | null;
  reportTimestamp?: string | null;
  createdAt?: string | null;
  reportFileStatus: number;
  url?: string | null;
};

export type DataDownloadsResponse = {
  dataDownload: DataDownloadInfo[];
  lastVisitedAt?: string | null;
  showSftpToggle?: boolean;
};

export type DataDownloadDetailsResponse = {
  downloadDetails: DataDownloadFile[];
};

export type UpdateReportSchedulingParams = CustomDataReportParams & {
  courseCustomDataReport: {
    recipientUserIds: number[];
    scheduledAt?: string;
  }
};
